import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Form } from "react-bootstrap";
import { Skeleton } from "@mui/material";
import { Add } from "iconsax-react";

import grouplImg from "../../../image/purchase/group-subscription.png";
import { cartApi, educationApi } from "../../../utility/api/apiList";

import cartType from "../../../redux/actions/cart/cartType";
import { showDangerAlert } from "../../../redux/actions/alert/alertActions";

import useAxios from "../../../hooks/useAxios";
import scrollToTop from "../../../libs/scrollToTop";

import LayoutPurchaseComponent from "../../../components/public/purchase/layoutPurchase";
import CartComponent from "../../../components/public/purchase/cart";
import CartTableComponent from "../../../components/public/purchase/cart/cartTable";
import SecondaryButtonComponent from "../../../components/public/purchase/secondaryButton";
import CompanyCardsSkeleton from "./companyCardsSkeleton";

import {
  Wrapper,
  StyledCreateNewCompany,
  StyledCompanyCardsWrapper,
} from "./styledcartPage";

const CartContainer = () => {
  const [productList, setProductList] = useState([]);

  const dispatch = useDispatch();

  const userDetail = useSelector((state) => state.userDetail);
  const companyDetail = useSelector((state) => state.companyDetail);
  const cartDetail = useSelector((state) => state.cartDetail);

  const theadData = [
    { id: 1, title: "مقطع تحصیلی" },
    { id: 2, title: "تعداد" },
    { id: 3, title: "بازه تحصیلی" },
    { id: 4, title: "مبلغ کل" },
  ];

  //useAxios
  const {
    isLoading: isCartDataLoading,
    error: cartError,
    run: cartRun,
  } = useAxios({
    url: cartApi,
  });

  const {
    data: educationList,
    isLoading: isEducationListLoading,
    run: educationRun,
  } = useAxios({
    url: educationApi,
    params: {
      order_by: "-id",
      page_size: 100,
    },
  });

  useEffect(() => {
    let search = "";
    const value = `; ${document.cookie}`;
    const parts = value.split(`; id=`);
    let cookieIdAxios = `?cookieId=${parts.pop().split(";").shift()}`;
    if (!userDetail.isLogin) {
      search = cookieIdAxios;
    }
    dispatch({ type: cartType.START_FETCHING_CART_DETAILS, search });

    scrollToTop();
    document.title = "سبد خرید اشتراک گروهی";

    cartRun().catch(() => {
      dispatch(showDangerAlert("سبد خرید شما خالی است"));
    });
    getEducationList();
  }, []);

  useEffect(() => {
    if (userDetail.isLogin) {
      if (cartDetail.error) {
        dispatch(showDangerAlert(cartDetail.errorMessage));
      }
      if (cartDetail.cart.length !== 0) {
        const productData = cartDetail.cart.data;
        let finalProductArray = [];
        for (let index = 0; index < Object.keys(productData).length; index++) {
          const newElemment = {
            grade: productData[index].grade,
            gradeName: productData[index].grade.name,
            number: productData[index].count,
            dateId: productData[index].unitoftime.id,
            unitOfTimeName: productData[index].unitoftime.name,
            price: productData[index].unitoftime.price,
            priceWithNoDiscount: productData[index].raw_price,
            discount: productData[index].discount,
            totalPrice: productData[index].total_price,
          };

          finalProductArray.push(newElemment);
        }

        setProductList(finalProductArray);
      }
    } else {
      dispatch(showDangerAlert("برای مشاهده جزئیات خرید لطفا ابتدا وارد شوید"));
    }
  }, [cartDetail.cart]);

  const getEducationList = () => {
    setTimeout(() => {
      educationRun().then(() => {
        setTimeout(() => {
          if (companyDetail?.companySelected.length !== 0) {
            if (document.getElementById(companyDetail.companySelected.id)) {
              document.getElementById(
                companyDetail.companySelected.id
              ).checked = true;
            }
          }
        }, 800);
      });
    }, 200);
  };

  const CartSkeletonComponent = () => {
    return (
      <LayoutPurchaseComponent
        classname="p-0 p-md-4"
        cardTitle="اشتراک گروهی"
        $height="auto"
        rowClassName="w-100"
      >
        <Wrapper className="p-0 d-flex flex-column justify-content-center align-items-center">
          <img
            src={grouplImg}
            alt="اشتراک گروهی"
            width="280"
            height="auto"
            className="mb-3"
          />
          <CartTableComponent theadData={theadData} className="px-md-1">
            {productList.map((item, index) => (
              <tr
                key={`tr-${index}`}
                className={index === productList.length - 1 ? "tbody-last-tr" : ""}
              >
                <td>
                  <Skeleton />
                </td>
                <td>
                  <Skeleton />
                </td>
                <td>
                  <Skeleton />
                </td>
                <td>
                  <Skeleton />
                </td>
              </tr>
            ))}
          </CartTableComponent>

          <Form className="w-100">
            <StyledCompanyCardsWrapper className="mx-auto px-2 px-md-0">
              {educationList?.results.map((item) => (
                <CompanyCardsSkeleton key={item.id} />
              ))}
              <StyledCreateNewCompany
                to="#"
                className="w-100 d-flex flex-column justify-content-center align-items-center"
              >
                <p className="m-1 text-center">ایجاد سازمان جدید</p>
                <Add size="32" color="var(--tertiary-color)" />
              </StyledCreateNewCompany>
            </StyledCompanyCardsWrapper>
            <SecondaryButtonComponent
              titleButton="ادامه و تایید خرید"
              buttonType="submit"
              isDisabledButton={true}
              wrapperButtonclassName="float-start col-12 col-md-3 my-5 my-md-3 mx-auto mx-md-0 px-3 px-md-1"
            />
          </Form>
        </Wrapper>
      </LayoutPurchaseComponent>
    );
  };

  const EmptyCartComponent = () => {
    return (
      <LayoutPurchaseComponent
        classname="p-0 p-md-4"
        cardTitle="اشتراک گروهی"
        $height="auto"
        rowClassName="w-100"
      >
        <Wrapper className="p-0 d-flex flex-column justify-content-center align-items-center">
          <img
            src={grouplImg}
            alt="اشتراک گروهی"
            width="280"
            height="auto"
            className="mb-3"
          />
        </Wrapper>
      </LayoutPurchaseComponent>
    );
  };

  let element = null;
  if (!userDetail.isLogin || cartError) {
    element = <EmptyCartComponent />;
  } else if (isCartDataLoading || isEducationListLoading) {
    element = <CartSkeletonComponent />;
  } else {
    element = (
      <CartComponent
        educationList={educationList}
        getEducationList={getEducationList}
        productList={productList}
        theadData={theadData}
      />
    );
  }
  return element;
};

export default CartContainer;
